"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/LinkBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



var _ui = require('web/services/ui');














const LinkBar = (props) => {
  const {
    link,
    className,
    iconClassName,
    isIconLabelShown,
  } = props

  const linkTextRef = _react.useRef(null)

  const handleClick = async () => {
    const { onShare, onCopy } = props
    await (props.isNativeSharingAvailable ? onShare() : onCopy())
    // SAFETY: the span is mounted while it can be clicked; selectTextNode
    // rejects a missing node, as it did in JS.
    return _ui.selectTextNode.call(void 0, linkTextRef.current )
  }

  const rootClassName = _classBuilder2.default.call(void 0, 'meeting--link-bar', className)
  const iconWrapperClassName = _classBuilder2.default.call(void 0, 
    'meeting--link-bar--icon',
    { sharing: _ui.isNativeSharingAvailable },
    iconClassName,
  )
  const iconLabelClassName = _classBuilder2.default.call(void 0, 
    'meeting--link-bar--icon--label',
    { hidden: !isIconLabelShown },
  )

  return (
    _react2.default.createElement('div', {
      onClick: handleClick,
      className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}

      , _react2.default.createElement('span', {
        ref: linkTextRef,
        className: "meeting--link-bar--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}

        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, link)
      )
      , _react2.default.createElement('div', { className: iconWrapperClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}} )
        ,  isIconLabelShown &&
          _react2.default.createElement('span', { className: iconLabelClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
            , 
              _ui.isNativeSharingAvailable
                ? 'Share link'
                : 'Copy link'
            
          )
        
      )
    )
  )
}

exports. default = LinkBar
